function findCountryCode(country) {
    var countries = {
        "AT": "Austria",
        "BE": "Belgium",
        "CH": "Switzerland",
        "DE": "Germany",
        "DK": "Denmark",
        "ES": "Spain",
        "FR": "France",
        "GB": "United Kingdom",
        "IT": "Italy",
        "LUX": "Luxembourg",
        "PL": "Poland",
        "SE": "Sweden",
        "SK": "Slovakia",
        "SVN": "Slovenia",
        "HU": "Hungary",
        "CZ": "Czechia"
    };

    for (var code in countries) {
        if (countries[code].toLowerCase() === country.toLowerCase()) {
            return code;
        }
    }

    return null; // Country code not found
}

function finddestination(data, country) {
    var countryCode = findCountryCode(country);
    return data.filter(row => row.landcode === countryCode);
}